import '~/styles/global.scss';

import type { GatsbyBrowser, PageProps } from 'gatsby';
import React from 'react';
import { PageElementWrapper, type PageWrapperProps } from '~/shared/libs/gatsby-plugin-i18n/wrapPageElement';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}: {
  element: React.ReactElement;
  props: PageProps;
}) => {
  const { pageContext } = props as PageWrapperProps;

  return <PageElementWrapper element={element} pageContext={pageContext} />;
};

export const onClientEntry: GatsbyBrowser['onClientEntry'] = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
    console.log('IntersectionObserver polyfill enabled');
  }

  if (navigator.userAgent.includes('Trident')) {
    const smoothscroll = await import('smoothscroll-polyfill');
    smoothscroll.polyfill();
    console.log('SmoothScroll polyfill enabled');
  }

  if (typeof window.requestIdleCallback === 'undefined') {
    // @ts-ignore
    await import('requestidlecallback-polyfill');
    console.log('requestIdleCallback polyfill enabled');
  }

  if (window.NodeList && !NodeList.prototype.forEach) {
    // @ts-ignore
    NodeList.prototype.forEach = Array.prototype.forEach;
    console.log('NodeList.prototype.forEach polyfill enabled');
  }
};
